import { Injectable } from '@angular/core';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { NotificationDialogComponent } from 'editing-tool/src/app/shared/notification/notification-dialog/notification-dialog.component';
import { NotificationDialogData } from 'editing-tool/src/app/shared/notification/notification-dialog-data';

@Injectable({
    providedIn: 'root'
})
export class NotificationDialogService {

    constructor(private readonly _dialogService: DialogService) { }

    public showMessage(messageData: NotificationDialogData): DynamicDialogRef {

        const data = new NotificationDialogData();

        Object.assign(data, messageData);

        return this._dialogService.open(NotificationDialogComponent, {
            width: data.width,
            showHeader: false,
            dismissableMask: true,
            closable: true,
            data: data
        });
    }
}
